import { Component, EventEmitter, Input, NgZone, OnChanges, Output , ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import {
    SearchCustomerAction
} from '../../models/models';

@Component({
    selector: 'customer-action-grid',
    templateUrl: './customer-action-grid.component.html',
    standalone: false
})
export class CustomerActionGrid implements OnChanges {
    @Input() title: string = "Actions";
    @Input() expanded: boolean = true;
    @Input() customerID: number = 0;
    @Input() opportunityID: number = 0;

    @Output() customerActionSaved: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild(GridComponent, { static: false }) public customerActionGrid!: GridComponent;

    public isEdit: boolean = false;
    public isAdd: boolean = false;

    public customerActionID: number = 0;
    public customerActionList: SearchCustomerAction[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'eventDate' }] };

    constructor(private crmService: CRMService, private utilService: UtilService,
        private datePipe: DatePipe, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getCustomerActions();
    }

    private getCustomerActions() {
        if (this.opportunityID > 0) {
            this.utilService.isLoading = true;
            this.crmService.getSearchCustomerActionByOpportunityID(this.opportunityID).subscribe(result => {
                this.utilService.isLoading = false;
                this.customerActionList = result.resultCollection;
                this.setGrid();
            });
        }
        else if (this.customerID > 0) {
            this.utilService.isLoading = true;
            this.crmService.getSearchCustomerActionByCustomerID(this.customerID).subscribe(result => {
                this.utilService.isLoading = false;
                this.customerActionList = result.resultCollection;
                this.setGrid();
            });
        }
    }

    public getActionNotes(customerAction: SearchCustomerAction) {
        var isFollowUp = customerAction.parentCustomerActionID > 0 && customerAction.actionTypeID < 0;

        if (isFollowUp) {
            if (customerAction.parentCustomerActionID == null) {
                return "";
            }
            else {
                return 'Follow Up to ' + customerAction.parentCustomerActionTypeDesc + ' (' + this.datePipe.transform(new Date(customerAction.parentEventDate), 'M/dd/yyyy') + '): ' + customerAction.parentCustomerActionNotes;
            }
        } else {
            return customerAction.customerActionNotes;
        }
    }

    private setGrid() {
        if (this.gridState.sort) this.customerActionList = orderBy(this.customerActionList, this.gridState.sort);

        this.gridData = process(this.customerActionList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.customerActionGrid == null) return;
            this.customerActionGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public edit(customerActionID: number) {
        this.customerActionID = customerActionID;
        this.isEdit = true;
        this.isAdd = false;
    }

    public addNew() {
        this.customerActionID = 0;
        this.isEdit = false;
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
        this.getCustomerActions();
        this.customerActionSaved.emit();
    }
}
